import { useEffect } from "react";
import { Controller, useWatch } from "react-hook-form";
import { CustomPinInput } from "../../ui/CustomPin/CustomPin";
import { CustomText } from "../../ui/CustomText/CustomText";
import { pinSetupValidators } from "../../../lib/validations/authValidations";

export default function PinSetupFields({
  control,
  disabled = false,
  validateNewPin,
  trigger,
}) {
  const newPin = useWatch({ control, name: "newPin" });
  const confirmPin = useWatch({ control, name: "confirmPin" });

  useEffect(() => {
    if (confirmPin) trigger?.("confirmPin");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newPin]);

  return (
    <>
      <CustomText size="sm" c="dimmed" align="center">
        New PIN
      </CustomText>
      <Controller
        name="newPin"
        control={control}
        rules={{
          validate: (v) =>
            pinSetupValidators.newPin(v) ??
            (validateNewPin ? validateNewPin(v) : null) ??
            true,
        }}
        render={({ field, fieldState }) => (
          <>
            <CustomPinInput
              length={6}
              mask
              disabled={disabled}
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
            />
            {fieldState.error && (
              <CustomText c="error" size="sm" align="center">
                {fieldState.error.message}
              </CustomText>
            )}
          </>
        )}
      />

      <CustomText size="sm" c="dimmed" align="center" mt="lg">
        Confirm PIN
      </CustomText>
      <Controller
        name="confirmPin"
        control={control}
        rules={{
          validate: (v) => pinSetupValidators.confirmPin(newPin, v) ?? true,
        }}
        render={({ field, fieldState }) => (
          <>
            <CustomPinInput
              length={6}
              mask
              disabled={disabled}
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
            />
            {fieldState.error && (
              <CustomText c="error" size="sm" align="center">
                {fieldState.error.message}
              </CustomText>
            )}
          </>
        )}
      />
    </>
  );
}
